module.exports = __webpack_public_path__ + "67954b1a86ddc259c2157bc270b9e91e.jpg";